import { createTheme, validateTheme, TextStyleParams } from '@codeleap/styles'
import { LocalStorage } from '../localStorage'
import { effects } from './effects'
import { Icons } from '../assets/icons'

import measures from './measures'
import baseColors from './colors/baseColors'
import lightMode from './colors/lightMode'
import darkMode from './colors/darkMode'
import { IS_SSR } from '../constants'
import { CompanyTheme } from '../packages'
const themeSpacing = 8

export const theme = createTheme(
  validateTheme({
    baseColors: CompanyTheme.colorProxy,
    originalBaseColors: baseColors,
    colors: lightMode,
    alternateColors: {
      dark: { ...lightMode, ...darkMode },
    },
    baseSpacing: themeSpacing,
    radius: measures.radius,
    stroke: measures.stroke,
    size: measures.itemSize,
    effects,
    typography: {
      fonts: {
        Inter: 'Inter',
        DMSans: 'DMSans',
      },
      defaults: {
        fontWeight: '400',
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontSize: 16,
        lineHeight: 'auto',
        letterSpacing: 0,
      } as unknown as TextStyleParams,
    },
    icons: Icons,
    presets: {
      safeHorizontalPaddings: () => ({
        desktopHuge: 20 * themeSpacing,
        desktopLarge: 18 * themeSpacing,
        desktop: 16 * themeSpacing,
        laptop: 12 * themeSpacing,
        tablet: 8 * themeSpacing,
        tabletSmall: 4 * themeSpacing,
        mobile: 2 * themeSpacing,
      }),
      debugger: function (
        color: 'blue' | 'red' | 'yellow' | 'green' | 'purple' = 'red',
        background = false,
      ) {
        const hex = color === 'purple' ? '#9400D3' : color

        return {
          borderWidth: 1,
          borderColor: hex,
          color: hex,
          ...(background ? { backgroundColor: hex } : {}),
        }
      },
    },
    breakpoints: {
      mobile: 600,
      tabletSmall: 900,
      tablet: 1050,
      laptop: 1200,
      desktop: 1400,
      desktopLarge: 1800,
      desktopHuge: 2559,
    },
    isBrowser: true,
    values: {
      height: 10,
      width: 10,
      pixel: 1,
      innerSpacing: { X: 2, Y: 2, value: 16 },
      outerSpacing: { X: 2, Y: 2, value: 16 },
      iconSize: {
        1: 16,
        1.5: 18,
        2: 20,
        3: 24,
        4: 32,
        5: 48,
        6: 64,
      },
      headerHeight: 60,
      maxContentWidth: 1280,
    },
  }),
  {
    set: (name, value) => {
      if (IS_SSR) return
      localStorage.setItem(name, JSON.stringify(value))
    },
    get: (name) => {
      if (IS_SSR) return null
      const value = localStorage.getItem(name)
      return !!value ? JSON.parse(value) : null
    },
  },
)

export type AppThemeType = typeof theme
